import User from 'components/Pages/Registration/User/User';

export default User;
